import Link from 'next/link';
import React from 'react';
import { handleFreeReturn } from '@lambda/commons/helpers';
import settings from '@/settings';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const freeReturnDays = handleFreeReturn(
  settings.store,
  settings.free_return_days,
);

const DefaultProductSeo = () => {
  const { product } = useProductPageContext();

  const description = product.description ?? '';

  // Do not render if description exists
  if (description) {
    return null;
  }

  const productName = product.name ?? '';

  return (
    <div className="-mb-10 bg-[#F9F9F9] py-10">
      <div className="reebelo-container w-full text-sm">
        <h2 className="text-lg font-semibold xl:text-xl">
          {t`Buy Refurbished ${{ productName }} in ${{
            country: t(settings.country),
          }}`}
        </h2>
        <div className=" text-gray-700">
          <p>
            {t`Looking to buy an affordable ${{
              productName,
            }}? Find great deals for unlocked, used ${{ productName }} at`}{' '}
            <Link
              href="/"
              className="font-semibold text-blue-500 focus:outline-none"
            >
              Reebelo
            </Link>
            .{' '}
            {t`All our second hand ${{
              productName,
            }} devices are refurbished, 100% functional and sold by trustworthy ${{
              citizen: settings.country_citizen,
            }} vendors. Enjoy up to 12 months warranty, a ${{
              freeReturnDays,
            }}-day return policy & free delivery. No matter if you are looking for a new ${{
              productName,
            }} or a refurbished ${{
              productName,
            }} - find the best prices at`}{' '}
            <Link
              href="/"
              className="font-semibold text-blue-500 focus:outline-none"
            >
              Reebelo
            </Link>
            !
          </p>
        </div>
      </div>
    </div>
  );
};

export default DefaultProductSeo;
